import React from "react";
import { Grid, Box , Button} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { manageDataRoute } from "../../../routes/routeConstants"; // adjust import
import Buttons from "../../../components/Controls/Buttons/Button";
import { useSelector } from "react-redux";
import Label from "../../../components/Label/Label";
const tabOptions = [
  { label: "Review Batches", value: manageDataRoute.reviewBatches },
  { label: "Upload Summary", value: manageDataRoute.reviewList },
];

export default function ManageDataTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get last part of path (e.g. "review-list")
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const mainTab = pathSegments[pathSegments.length - 1];

  const selectedTab =
    tabOptions.find((tab) => tab.value === mainTab)?.value ||
    manageDataRoute.reviewList;

  const { product, site, unitOfOperation } = useSelector(
    (state) => state.shared.productSitesUopValues || {}
  );

  const handleNavigate = (tab) => {
    navigate(`/${tab}`); // ✅ relative navigation
  };

  return (
    <Box alignItems="center" spacing={1}>
      <Box item sx={{ display: "flex", gap: 0.5, flexWrap: "wrap" }}>
        {tabOptions.map((tab) => {
          const isSelected = selectedTab === tab.value;
          const isDisabled =
            selectedTab === "Upload Summary" || selectedTab === "Review Batches"
              ? false
              : !unitOfOperation?.id;
          return (
            <Button
              variant="text"
              disabled={isDisabled}
              onClick={() => handleNavigate(tab.value)}
              sx={{
                textTransform: "none",
                minWidth: `${Math.max(tab.label.length * 7 + 16, 80)}px`,
                backgroundColor: isSelected ? "#154D8F" : "transparent",
                color: isSelected ? "#fff" : "#000",
                "&:hover": {
                  backgroundColor: isSelected ? "#154D8F" : "transparent",
                },
                "&.Mui-disabled": { color: "#a0a0a0", pointerEvents: "auto" },
              }}
            >
              <Label
                text={tab.label}
                color={isDisabled ? "#a0a0a0" : isSelected ? "#fff" : "#000"}
              />
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}
